"use client";

import { c as _c } from "react/compiler-runtime";
import { IconArrowUpRightOutline18 } from "nucleo-ui-outline-18";
import { cn } from "@/lib/utils";
import Link, { LinkProps } from "next/link";
import { usePathname } from "next/navigation";
import React, { useState, ComponentType } from "react";
interface Links {
  label: string;
  href?: string;
  icon: ComponentType<{
    className?: string;
  }>;
  onClick?: () => void;
}
export const Sidebar = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <>{children}</>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export const SidebarBody = t0 => {
  const $ = _c(10);
  let children;
  let className;
  let collapsed;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      children,
      collapsed,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = collapsed;
    $[4] = props;
  } else {
    children = $[1];
    className = $[2];
    collapsed = $[3];
    props = $[4];
  }
  let t1;
  if ($[5] !== children || $[6] !== className || $[7] !== collapsed || $[8] !== props) {
    t1 = <DesktopSidebar className={className} collapsed={collapsed} {...props}>{children}</DesktopSidebar>;
    $[5] = children;
    $[6] = className;
    $[7] = collapsed;
    $[8] = props;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  return t1;
};
export const DesktopSidebar = t0 => {
  const $ = _c(12);
  let children;
  let className;
  let collapsed;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      children,
      collapsed,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = collapsed;
    $[4] = props;
  } else {
    children = $[1];
    className = $[2];
    collapsed = $[3];
    props = $[4];
  }
  const t1 = collapsed ? "w-14" : "w-[236px]";
  let t2;
  if ($[5] !== className || $[6] !== t1) {
    t2 = cn("flex h-full shrink-0 flex-col", t1, className);
    $[5] = className;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== children || $[9] !== props || $[10] !== t2) {
    t3 = <div className={t2} {...props}>{children}</div>;
    $[8] = children;
    $[9] = props;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
};
export const SidebarLink = t0 => {
  const $ = _c(52);
  let className;
  let dataGuide;
  let link;
  let onClick;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      link,
      className,
      onClick,
      noLink: t1,
      dataGuide,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = dataGuide;
    $[3] = link;
    $[4] = onClick;
    $[5] = props;
    $[6] = t1;
  } else {
    className = $[1];
    dataGuide = $[2];
    link = $[3];
    onClick = $[4];
    props = $[5];
    t1 = $[6];
  }
  const noLink = t1 === undefined ? false : t1;
  const [isMouseHovered, setIsMouseHovered] = useState(false);
  const pathname = usePathname();
  const isHovered = !noLink && (isMouseHovered || pathname === link.href);
  let t2;
  if ($[7] !== link.href) {
    t2 = link.href?.startsWith("http");
    $[7] = link.href;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const isExternal = t2;
  let t3;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = cn("flex h-10 w-10 shrink-0 cursor-pointer items-center justify-center rounded-lg transition-colors");
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const T0 = link.icon;
  const t4 = isHovered ? "text-blue-600 dark:text-blue-400" : "text-ds-text-subtle dark:text-ds-text-disabled group-hover/sidebar:text-blue-600 dark:group-hover/sidebar:text-blue-400";
  let t5;
  if ($[10] !== t4) {
    t5 = cn("h-5 w-5 transition-colors", t4);
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== link.icon || $[13] !== t5) {
    t6 = <div className={t3}><T0 className={t5} /></div>;
    $[12] = link.icon;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  const t7 = isHovered ? "text-blue-600 dark:text-blue-400" : "text-ds-text-secondary group-hover/sidebar:text-ds-text-primary dark:group-hover/sidebar:text-white";
  let t8;
  if ($[15] !== t7) {
    t8 = cn("m-0! p-0! inline-block cursor-pointer items-center gap-1 whitespace-pre text-xs font-medium uppercase tracking-wide transition duration-150", t7);
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== isExternal || $[18] !== isHovered) {
    t9 = isExternal && <IconArrowUpRightOutline18 className={cn("h-4 w-4", isHovered ? "text-blue-600 dark:text-blue-400" : "text-ds-text-subtle dark:text-ds-text-disabled")} />;
    $[17] = isExternal;
    $[18] = isHovered;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== link.label || $[21] !== t9) {
    t10 = <div className="flex items-center gap-2">{link.label}{t9}</div>;
    $[20] = link.label;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== t10 || $[24] !== t8) {
    t11 = <span className={t8}>{t10}</span>;
    $[23] = t10;
    $[24] = t8;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== t11 || $[27] !== t6) {
    t12 = <>{t6}{t11}</>;
    $[26] = t11;
    $[27] = t6;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  const commonContent = t12;
  if (!link.href) {
    const t13 = onClick || link.onClick;
    let t14;
    let t15;
    if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
      t14 = () => setIsMouseHovered(true);
      t15 = () => setIsMouseHovered(false);
      $[29] = t14;
      $[30] = t15;
    } else {
      t14 = $[29];
      t15 = $[30];
    }
    const t16 = isHovered && "text-b3-primary";
    let t17;
    if ($[31] !== className || $[32] !== t16) {
      t17 = cn("group/sidebar relative flex cursor-pointer items-center justify-start gap-3", className, t16);
      $[31] = className;
      $[32] = t16;
      $[33] = t17;
    } else {
      t17 = $[33];
    }
    let t18;
    if ($[34] !== commonContent || $[35] !== dataGuide || $[36] !== t13 || $[37] !== t17) {
      t18 = <div onClick={t13} onMouseEnter={t14} onMouseLeave={t15} className={t17} data-guide={dataGuide}>{commonContent}</div>;
      $[34] = commonContent;
      $[35] = dataGuide;
      $[36] = t13;
      $[37] = t17;
      $[38] = t18;
    } else {
      t18 = $[38];
    }
    return t18;
  }
  const t13 = link.href;
  let t14;
  if ($[39] !== className) {
    t14 = cn("group/sidebar relative flex cursor-pointer items-center justify-start gap-3 pl-1", className);
    $[39] = className;
    $[40] = t14;
  } else {
    t14 = $[40];
  }
  const t15 = onClick || link.onClick;
  let t16;
  let t17;
  if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = () => setIsMouseHovered(true);
    t17 = () => setIsMouseHovered(false);
    $[41] = t16;
    $[42] = t17;
  } else {
    t16 = $[41];
    t17 = $[42];
  }
  const t18 = isExternal ? "_blank" : undefined;
  const t19 = isExternal ? "noopener noreferrer" : undefined;
  let t20;
  if ($[43] !== commonContent || $[44] !== dataGuide || $[45] !== link.href || $[46] !== props || $[47] !== t14 || $[48] !== t15 || $[49] !== t18 || $[50] !== t19) {
    t20 = <Link href={t13} prefetch={false} className={t14} {...props} onClick={t15} onMouseEnter={t16} onMouseLeave={t17} target={t18} rel={t19} data-guide={dataGuide}>{commonContent}</Link>;
    $[43] = commonContent;
    $[44] = dataGuide;
    $[45] = link.href;
    $[46] = props;
    $[47] = t14;
    $[48] = t15;
    $[49] = t18;
    $[50] = t19;
    $[51] = t20;
  } else {
    t20 = $[51];
  }
  return t20;
};